<template>
  <div>
    <h4 v-if="!isMyEntityPage" class="section-title">
      <span>{{ $i18n.t('UserForm.other_entities') }}</span>
    </h4>

    <div class="user-entities-cards">
      <div class="card card-shadow" v-for="(candidateEntity, index) in candidateEntities" :key="index">
        <div class="card-header">
          <div class="row">
            <div class="col">

              <div>{{ entityName(candidateEntity) }}</div>
              <div :class="resourceTypeClass(candidateEntity)">{{ resourceType(candidateEntity) }}</div>
            </div>

            <div v-if="showProviderId && candidateEntity.unavailability_dates_provider_id" class="col">
              <div>Matricule :</div>
              <div><b>{{ candidateEntity.unavailability_dates_provider_id }}</b></div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md mb-3 mb-md-0">
              <div class="description">Service(s) de remplacement(s): </div>

              <services-grouped-by-hubs :services="candidateEntity.services"
                                        :hubs="candidateEntity.entity.hubs" />
            </div>

            <div class="col-md mb-3 mb-md-0" v-if="candidateEntity.affiliated_service">
              <div class="description">Service de rattachement: </div>


              <services-grouped-by-hubs v-if="candidateEntity.resource_type == 'intern'"
                                        :services="[candidateEntity.affiliated_service]"
                                        :hubs="candidateEntity.entity.hubs"
                                        :shortened="true" />
            </div>

            <div class="col-md mb-3 mb-md-0" v-if="affiliatedService.length > 0">
              <div class="description">Métier(s): </div>
              <div><b>{{ occupation_name(candidateEntity) }}</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

  export default {
    name: 'CandidateEntitiesTable',
    props: ['candidateEntities', 'isMyEntityPage'],
    components: {
      ServicesGroupedByHubs
    },
    computed: {
      ...mapGetters({
        usersSiblingEntities: 'users/siblingEntities'
      }),
      siblingEntities() {
        if (this.isMyEntityPage) {
          return this.candidateEntities
        }
        return this.usersSiblingEntities
      },
      tableHeadings() {
        let headings = [
          { key: 'entity', value: this.$t('table.headers.entity') },
          { key: 'internal', value: this.$t('table.headers.candidate_entity_internal') },
          { key: 'services', value: this.$t('table.headers.services') },
          { key: 'affiliation_service', value: this.$t('table.headers.affiliation_service') },
          { key: 'occupations', value: this.$t('table.headers.occupation') }
        ]
        if (this.showProviderId) {
          headings.push({
            key: 'provider_id',
            value: this.$t('table.headers.provider_id')
          })
        }
        return headings
      },
      showProviderId() {
        return this.isMyEntityPage || this.expectingProviderId
      },
      expectingProviderId() {
        return this.usersSiblingEntities
                   .map(entity => entity.unavailabilities_provider_scope)
                   .includes('entity')
      }
    },
    methods: {
      services_name(candidateEntity) {
        return candidateEntity.services.map(service => service.name).join(' / ')
      },
      occupation_name(candidateEntity) {
        return candidateEntity.occupations.map(occupation => occupation.name).join(' / ')
      },
      entityName(candidateEntity) {
        if (this.isMyEntityPage) {
          return this.siblingEntities.find(item => item.entity.id == candidateEntity.entity.id).entity.name
        }
        return this.siblingEntities.find(entity => entity.id == candidateEntity.entity_id).name
      },
      resourceType(candidateEntity) {
        return candidateEntity.resource_type == 'intern' ? this.$i18n.t('models.resource_type.intern') : this.$i18n.t('models.resource_type.extern')
      },
      affiliatedService(candidateEntity) {
        return candidateEntity.resource_type == 'intern' ? candidateEntity.affiliated_service.name : ''
      },
      resourceTypeClass(addOn) {
        return addOn.resource_type == 'intern' ? 'badge-intern' : 'badge-extern'
      },
    }
  }
</script>

<style scoped>
  h4.section-title {
    width: 100%;
    text-align: left;
    border-bottom: 2px solid #f1f1f1;
    line-height: 0.1em;
    margin: 10px 0 20px;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 14px;
  }

  .section-title span {
    background: #fff;
    padding: 0 10px;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidateEntitiesTable.vue